import moment from 'moment/moment'

export const partyAsList = [
  { id: 0, name: 'Both - Sender & Receiver' },
  { id: 1, name: 'Sender' },
  { id: 2, name: 'Receiver' },
  { id: 3, name: 'Payment Responsibility' },
]

//-----------------------booking const--------------------
export const excelHeader = [
  { col: 3, value: 'From Booking Date' },
  { col: 1, value: 'To Booking Date' },
  { col: 1, value: 'Booking Branch' },
  { col: 1, value: 'User' },
  { col: 1, value: 'Party' },
  { col: 1, value: 'Party As' },
]

// export const detailedHeader = {
// srNo: 'SN',
// LRNO: 'LR No.\nMan LR No',
// BkgDtBkgTime: 'Bkg. Date\nBkg. Time',
// SrcCitySrcBranch: 'Src. City\nSrc. Br.',
// DstCityBranch: 'Dst. City\nDst. Br',
// SendNameSendNo: 'Sndr. Name\nSndr. No.\nSndr. GSTIN\nSndr. eMail.',
// RecNameRecNo: 'Rec. Name\nRec. No.\nRec. GSTIN\nRec. eMail.',
// BkdByUser: 'Bkg. By\nUser',
// ItemName: 'Item\nName',
// Status: 'LR\nStatus',
// ItemUnits: 'Item\nUnits',
// Freight: 'Frt.\nChrg',
// Document: 'Doc.\nChrg',
// CartageAmount: 'Cart.\nChrg',
// HamaliCharges: 'Ham. Chrg',
// OptHamaliCharges: 'op. Ham.',
// Valuation: 'Val. Chrg',
// OtherCharges: 'oth. Chrg',
// BookingGST: 'Bkg. GST',
// NetAmount: 'Net Amt',
// DeliveryHamali: 'Del. Ham',
// DeliveryCartage: 'Del. Cart',
// DemurageCharge: 'Dem. Chrg',
// DeliveryGst: 'Del. Gst',
// NetAmount1: 'NetO/S Amt',
// isHeading: true,
// }
export const detailedHeader1 = {
  srNo: 'SN',
  LRNO: 'LR No.\nMan LR No',
  FormattedLRNO: 'Formatted \nLRNO',
  BkgDtBkgTime: 'Bkg. Date\nBkg. Time',
  SrcCitySrcBranch: 'Src. City\nSrc. Br.',
  DstCityBranch: 'Dst. City\nDst. Br',
  SendNameSendNo: 'Sndr. Name\nSndr. No.',
  SendGstinSendEmail: 'Sndr. GSTIN\nSndr. eMail.',
  RecNameRecNo: 'Rec. Name\nRec. No.',
  RecGstinRecEmail: 'Rec. GSTIN\nRec. eMail.',
  BkdByUser: 'Bkg. By\nUser',
  ItemDetails: 'Item\nName',
  Status: 'LR\nStatus',
  RefByRefByBr: 'Ref. By\nRef. By Br.',
  RefDateRefTime: 'Ref. Date\nRef. Time',
  Items: 'Item\nUnits',
  Freight: 'Frt.\nChrg',
  DocumentCharges: 'Doc.\nChrg',
  CartageAmount: 'Cart.\nChrg',
  HamaliCharges: 'Ham.\nChrg',
  OperatorHamaliChg: 'op.\nHam.',
  Valuation: 'Val.\nChrg',
  OtherCharge: 'oth.\nChrg',
  BookingGST: 'Bkg.\nGST',
  Outstanding: 'NetO/S\nAmt.',
  RefundAmount: 'Ref.\nAmt.',
  //isRefundHeading: true,
  isHeading: true,
}

export const detailedHeader2 = {
  srNo: 'SN',
  LRNO: 'LR No.\nMan LR No',
  BkgDtBkgTime: 'Bkg. Date\nBkg. Time',
  SrcCitySrcBranch: 'Src. City\nSrc. Br.',
  DstCityBranch: 'Dst. City\nDst. Br',
  SendNameSendNo: 'Sndr. Name\nSndr. No.',
  SendGstinSendEmail: 'Sndr. eMail.',
  RecNameRecNo: 'Rec. Name\nRec. No.',
  RecGstinRecEmail: 'Rec. eMail.',
  BkdByUser: 'Bkg. By\nUser',
  ItemDetails: 'Item\nName',
  Status: 'LR\nStatus',
  RefByRefByBr: 'Ref. By\nRef. By Br.',
  RefDateRefTime: 'Ref. Date\nRef. Time',
  Items: 'Item\nUnits',
  Freight: 'Frt.\nChrg',
  DocumentCharges: 'Doc.\nChrg',
  CartageAmount: 'Cart.\nChrg',
  HamaliCharges: 'Ham.\nChrg',
  OperatorHamaliChg: 'op.\nHam.',
  Valuation: 'Val.\nChrg',
  OtherCharge: 'oth.\nChrg',
  Outstanding: 'NetO/S\nAmt.',
  RefundAmount: 'Ref.\nAmt.',
  //isRefundHeading: true,
  isHeading: true,
}
export const pdfHeaderColumn = [
  {
    headerName: 'Booking Branch',
    exportHead: 'Booking Branch',
    field: 'bookingBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'User',
    exportHead: 'User',
    field: 'user',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Party',
    exportHead: 'Party',
    field: 'party',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Party As',
    exportHead: 'Party As',
    field: 'partyAs',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
]
//pdf header for credit delivery
export const onAccountDetailedColumn = [
  { headerName: 'S/N', exportHead: 'S/N', field: 'srNo', xlCol: { dataType: 'number', dataFormatter: null }, align: 'left' },
  {
    headerName: 'LR No.\n Man. LR No.',
    exportHead: 'LR No.\n Man. LR No.',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BkgDtBkgTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Src. City\nSrc. Br.',
    exportHead: 'Src. City\nSrc. Br.',
    field: 'SrcCitySrcBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dst. City\nDst. Br',
    exportHead: 'Dst. City\nDst. Br',
    field: 'DstCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Sender\nDetails',
    exportHead: 'Sender\nDetails',
    field: 'SendNameSendNo',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Receiver\nDetails',
    exportHead: 'Receiver\nDetails',
    field: 'RecNameRecNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. By\nUser ',
    exportHead: 'Bkg. By\nUser',
    field: 'BkdByUser',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Item\nName',
    exportHead: 'Item\nName',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'LR \nStatus',
    exportHead: 'LR \nStatus',
    field: 'Status',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Item\nUnits',
    exportHead: 'Item\nUnits',
    field: 'Items',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Frt. Chrg',
    exportHead: 'Frt. Chrg',
    field: 'Freight',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Doc. Chrg',
    exportHead: 'Doc. Chrg',
    field: 'DocumentCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cart.\nChrg',
    exportHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Ham. Chrg',
    exportHead: 'Ham. Chrg',
    field: 'HamaliCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'op. Ham.',
    exportHead: 'op. Ham.',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Val. Chrg',
    exportHead: 'Val. Chrg',
    field: 'Valuation',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'oth. Chrg',
    exportHead: 'oth. Chrg',
    field: 'OtherCharge',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Bkg. GST',
    exportHead: 'Bkg. GST',
    field: 'BookingGST',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net Amt',
    exportHead: 'Net Amt',
    field: 'NetAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del. Ham',
    exportHead: 'Del. Ham',
    field: 'DelHamali',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del. Cart',
    exportHead: 'Del. Cart',
    field: 'DelCartage',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Dem. Chrg',
    exportHead: 'Dem. Chrg',
    field: 'DemurrageChg',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del. Gst',
    exportHead: 'Del. Gst',
    field: 'DeliveryGST',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'NetO/S Amt',
    exportHead: 'NetO/S Amt',
    field: 'Outstanding',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
]
export const onAccountDetailedColumnTwo = [
  { headerName: 'S/N', exportHead: 'S/N', field: 'srNo', xlCol: { dataType: 'number', dataFormatter: null }, align: 'left' },
  {
    headerName: 'LR No.\n Man. LR No.',
    exportHead: 'LR No.\n Man. LR No.',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BkgDtBkgTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Src. City\nSrc. Br.',
    exportHead: 'Src. City\nSrc. Br.',
    field: 'SrcCitySrcBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dst. City\nDst. Br',
    exportHead: 'Dst. City\nDst. Br',
    field: 'DstCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Sender\nDetails',
    exportHead: 'Sender\nDetails',
    field: 'SendNameSendNo',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Receiver\nDetails',
    exportHead: 'Receiver\nDetails',
    field: 'RecNameRecNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. By\nUser ',
    exportHead: 'Bkg. By\nUser',
    field: 'BkdByUser',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Item\nName',
    exportHead: 'Item\nName',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'LR \nStatus',
    exportHead: 'LR \nStatus',
    field: 'Status',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Item\nUnits',
    exportHead: 'Item\nUnits',
    field: 'Items',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Frt. Chrg',
    exportHead: 'Frt. Chrg',
    field: 'Freight',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Doc. Chrg',
    exportHead: 'Doc. Chrg',
    field: 'DocumentCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cart.\nChrg',
    exportHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Ham. Chrg',
    exportHead: 'Ham. Chrg',
    field: 'HamaliCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'op. Ham.',
    exportHead: 'op. Ham.',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Val. Chrg',
    exportHead: 'Val. Chrg',
    field: 'Valuation',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'oth. Chrg',
    exportHead: 'oth. Chrg',
    field: 'OtherCharge',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net Amt',
    exportHead: 'Net Amt',
    field: 'NetAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del. Ham',
    exportHead: 'Del. Ham',
    field: 'DelHamali',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del. Cart',
    exportHead: 'Del. Cart',
    field: 'DelCartage',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Dem. Chrg',
    exportHead: 'Dem. Chrg',
    field: 'DemurrageChg',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'NetO/S Amt',
    exportHead: 'NetO/S Amt',
    field: 'Outstanding',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
]
export const onAccountDetailedColumnFormattedLrNo = [
  { headerName: 'S/N', exportHead: 'S/N', field: 'srNo', xlCol: { dataType: 'number', dataFormatter: null }, align: 'left' },
  {
    headerName: 'Formatted LRNO',
    exportHead: 'Formatted \nLRNO',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BkgDtBkgTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Src. City\nSrc. Br.',
    exportHead: 'Src. City\nSrc. Br.',
    field: 'SrcCitySrcBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dst. City\nDst. Br',
    exportHead: 'Dst. City\nDst. Br',
    field: 'DstCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Sender\nDetails',
    exportHead: 'Sender\nDetails',
    field: 'SendNameSendNo',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Receiver\nDetails',
    exportHead: 'Receiver\nDetails',
    field: 'RecNameRecNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. By\nUser ',
    exportHead: 'Bkg. By\nUser',
    field: 'BkdByUser',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Item\nName',
    exportHead: 'Item\nName',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'LR \nStatus',
    exportHead: 'LR \nStatus',
    field: 'Status',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Item\nUnits',
    exportHead: 'Item\nUnits',
    field: 'Items',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Frt. Chrg',
    exportHead: 'Frt. Chrg',
    field: 'Freight',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Doc. Chrg',
    exportHead: 'Doc. Chrg',
    field: 'DocumentCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cart.\nChrg',
    exportHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Ham. Chrg',
    exportHead: 'Ham. Chrg',
    field: 'HamaliCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'op. Ham.',
    exportHead: 'op. Ham.',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Val. Chrg',
    exportHead: 'Val. Chrg',
    field: 'Valuation',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'oth. Chrg',
    exportHead: 'oth. Chrg',
    field: 'OtherCharge',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Bkg. GST',
    exportHead: 'Bkg. GST',
    field: 'BookingGST',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net Amt',
    exportHead: 'Net Amt',
    field: 'NetAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del. Ham',
    exportHead: 'Del. Ham',
    field: 'DelHamali',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del. Cart',
    exportHead: 'Del. Cart',
    field: 'DelCartage',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Dem. Chrg',
    exportHead: 'Dem. Chrg',
    field: 'DemurrageChg',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del. Gst',
    exportHead: 'Del. Gst',
    field: 'DeliveryGST',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'NetO/S Amt',
    exportHead: 'NetO/S Amt',
    field: 'Outstanding',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
]
export const onAccountDetailedColumnFormattedLrNoTwo = [
  { headerName: 'S/N', exportHead: 'S/N', field: 'srNo', xlCol: { dataType: 'number', dataFormatter: null }, align: 'left' },
  {
    headerName: 'Formatted LRNO',
    exportHead: 'Formatted \nLRNO',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BkgDtBkgTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Src. City\nSrc. Br.',
    exportHead: 'Src. City\nSrc. Br.',
    field: 'SrcCitySrcBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dst. City\nDst. Br',
    exportHead: 'Dst. City\nDst. Br',
    field: 'DstCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Sender\nDetails',
    exportHead: 'Sender\nDetails',
    field: 'SendNameSendNo',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Receiver\nDetails',
    exportHead: 'Receiver\nDetails',
    field: 'RecNameRecNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. By\nUser ',
    exportHead: 'Bkg. By\nUser',
    field: 'BkdByUser',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Item\nName',
    exportHead: 'Item\nName',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'LR \nStatus',
    exportHead: 'LR \nStatus',
    field: 'Status',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Item\nUnits',
    exportHead: 'Item\nUnits',
    field: 'Items',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Frt. Chrg',
    exportHead: 'Frt. Chrg',
    field: 'Freight',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Doc. Chrg',
    exportHead: 'Doc. Chrg',
    field: 'DocumentCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cart.\nChrg',
    exportHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Ham. Chrg',
    exportHead: 'Ham. Chrg',
    field: 'HamaliCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'op. Ham.',
    exportHead: 'op. Ham.',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Val. Chrg',
    exportHead: 'Val. Chrg',
    field: 'Valuation',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'oth. Chrg',
    exportHead: 'oth. Chrg',
    field: 'OtherCharge',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net Amt',
    exportHead: 'Net Amt',
    field: 'NetAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del. Ham',
    exportHead: 'Del. Ham',
    field: 'DelHamali',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del. Cart',
    exportHead: 'Del. Cart',
    field: 'DelCartage',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Dem. Chrg',
    exportHead: 'Dem. Chrg',
    field: 'DemurrageChg',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'NetO/S Amt',
    exportHead: 'NetO/S Amt',
    field: 'Outstanding',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
]
export const onAccountDetailedColumnBoth = [
  { headerName: 'S/N', exportHead: 'S/N', field: 'srNo', xlCol: { dataType: 'number', dataFormatter: null }, align: 'left' },
  {
    headerName: 'LR No.\n Man. LR No.',
    exportHead: 'LR No.\n Man. LR No.',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Formatted LRNO',
    exportHead: 'Formatted LRNO',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BkgDtBkgTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Src. City\nSrc. Br.',
    exportHead: 'Src. City\nSrc. Br.',
    field: 'SrcCitySrcBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dst. City\nDst. Br',
    exportHead: 'Dst. City\nDst. Br',
    field: 'DstCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Sender\nDetails',
    exportHead: 'Sender\nDetails',
    field: 'SendNameSendNo',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Receiver\nDetails',
    exportHead: 'Receiver\nDetails',
    field: 'RecNameRecNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. By\nUser ',
    exportHead: 'Bkg. By\nUser',
    field: 'BkdByUser',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Item\nName',
    exportHead: 'Item\nName',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'LR \nStatus',
    exportHead: 'LR \nStatus',
    field: 'Status',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Item\nUnits',
    exportHead: 'Item\nUnits',
    field: 'Items',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Frt. Chrg',
    exportHead: 'Frt. Chrg',
    field: 'Freight',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Doc. Chrg',
    exportHead: 'Doc. Chrg',
    field: 'DocumentCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cart.\nChrg',
    exportHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Ham. Chrg',
    exportHead: 'Ham. Chrg',
    field: 'HamaliCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'op. Ham.',
    exportHead: 'op. Ham.',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Val. Chrg',
    exportHead: 'Val. Chrg',
    field: 'Valuation',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'oth. Chrg',
    exportHead: 'oth. Chrg',
    field: 'OtherCharge',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Bkg. GST',
    exportHead: 'Bkg. GST',
    field: 'BookingGST',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net Amt',
    exportHead: 'Net Amt',
    field: 'NetAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del. Ham',
    exportHead: 'Del. Ham',
    field: 'DelHamali',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del. Cart',
    exportHead: 'Del. Cart',
    field: 'DelCartage',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Dem. Chrg',
    exportHead: 'Dem. Chrg',
    field: 'DemurrageChg',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del. Gst',
    exportHead: 'Del. Gst',
    field: 'DeliveryGST',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'NetO/S Amt',
    exportHead: 'NetO/S Amt',
    field: 'Outstanding',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
]
export const onAccountDetailedColumnBothTwo = [
  { headerName: 'S/N', exportHead: 'S/N', field: 'srNo', xlCol: { dataType: 'number', dataFormatter: null }, align: 'left' },
  {
    headerName: 'LR No.\n Man. LR No.',
    exportHead: 'LR No.\n Man. LR No.',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Formatted LRNO',
    exportHead: 'Formatted LRNO',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BkgDtBkgTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Src. City\nSrc. Br.',
    exportHead: 'Src. City\nSrc. Br.',
    field: 'SrcCitySrcBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dst. City\nDst. Br',
    exportHead: 'Dst. City\nDst. Br',
    field: 'DstCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Sender\nDetails',
    exportHead: 'Sender\nDetails',
    field: 'SendNameSendNo',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Receiver\nDetails',
    exportHead: 'Receiver\nDetails',
    field: 'RecNameRecNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. By\nUser ',
    exportHead: 'Bkg. By\nUser',
    field: 'BkdByUser',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Item\nName',
    exportHead: 'Item\nName',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'LR \nStatus',
    exportHead: 'LR \nStatus',
    field: 'Status',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Item\nUnits',
    exportHead: 'Item\nUnits',
    field: 'Items',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Frt. Chrg',
    exportHead: 'Frt. Chrg',
    field: 'Freight',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Doc. Chrg',
    exportHead: 'Doc. Chrg',
    field: 'DocumentCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cart.\nChrg',
    exportHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Ham. Chrg',
    exportHead: 'Ham. Chrg',
    field: 'HamaliCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'op. Ham.',
    exportHead: 'op. Ham.',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Val. Chrg',
    exportHead: 'Val. Chrg',
    field: 'Valuation',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'oth. Chrg',
    exportHead: 'oth. Chrg',
    field: 'OtherCharge',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Net Amt',
    exportHead: 'Net Amt',
    field: 'NetAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del. Ham',
    exportHead: 'Del. Ham',
    field: 'DelHamali',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Del. Cart',
    exportHead: 'Del. Cart',
    field: 'DelCartage',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Dem. Chrg',
    exportHead: 'Dem. Chrg',
    field: 'DemurrageChg',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'NetO/S Amt',
    exportHead: 'NetO/S Amt',
    field: 'Outstanding',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
]
//pdf header for Refund
export const onAccountDetailedColumn1 = [
  { headerName: 'SN', exportHead: 'SN', field: 'srNo', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left' },
  {
    headerName: 'LR No.\n Man. LR No.',
    exportHead: 'LR No.\n Man. LR No.',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
    isSortIcon: true,
  },
  {
    headerName: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BookingDateTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
    isSortIcon: true,
  },
  {
    headerName: 'Src. City\nSrc. Br.',
    exportHead: 'Src. City\nSrc. Br.',
    field: 'BookingCity',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
    isSortIcon: true,
  },
  {
    headerName: 'Dst. City\nDst. Br',
    exportHead: 'Dst. City\nDst. Br',
    field: 'DestinationCity',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
    isSortIcon: true,
  },

  {
    headerName: 'Sndr. Name\nSndr. No.',
    exportHead: 'Sndr. Name\nSndr. No.',
    field: 'Sender',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
    isSortIcon: true,
  },
  {
    headerName: 'Sndr. GSTIN\nSndr. eMail.',
    exportHead: 'Sndr. GSTIN\nSndr. eMail.',
    field: 'SenderGSTN',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
    isSortIcon: true,
  },

  {
    headerName: 'Rec. Name\nRec. No.',
    exportHead: 'Rec. Name\nRec. No.',
    field: 'Receiver',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
    isSortIcon: true,
  },
  {
    headerName: 'Rec. GSTIN\nRec. eMail.',
    exportHead: 'Rec. GSTIN\nRec. eMail.',
    field: 'ReceiverGSTN',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
    isSortIcon: true,
  },
  {
    headerName: 'Bkg. By\nUser ',
    exportHead: 'Bkg. By\nUser',
    field: 'BookedBy',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
    isSortIcon: true,
  },
  {
    headerName: 'Item\nName',
    exportHead: 'Item\nName',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
    isSortIcon: true,
  },

  {
    headerName: 'LR\nStatus',
    exportHead: 'LR\nStatus',
    field: 'Status',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
    isSortIcon: true,
  },
  {
    headerName: 'Ref. By\nRef. By Br.',
    exportHead: 'Ref. By\nRef. By Br.',
    field: 'RefundByUser',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
    isSortIcon: true,
  },
  {
    headerName: 'Ref. Date\nRef. Time',
    exportHead: 'Ref. Date\nRef. Time',
    field: 'RefundDateTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
    isSortIcon: true,
  },
  {
    headerName: 'Item\nUnits',
    exportHead: 'Item\nUnits',
    field: 'Items',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
    isSortIcon: true,
  },
  {
    headerName: 'Frt. Chrg',
    exportHead: 'Frt. Chrg',
    field: 'Freight',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
    isSortIcon: true,
  },
  {
    headerName: 'Doc. Chrg',
    exportHead: 'Doc. Chrg',
    field: 'DocumentCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
    isSortIcon: true,
  },
  {
    headerName: 'Cart.\nChrg',
    exportHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
    isSortIcon: true,
  },
  {
    headerName: 'Ham. Chrg',
    exportHead: 'Ham. Chrg',
    field: 'HamaliCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
    isSortIcon: true,
  },
  {
    headerName: 'op. Ham.',
    exportHead: 'op. Ham.',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
    isSortIcon: true,
  },
  {
    headerName: 'Val. Chrg',
    exportHead: 'Val. Chrg',
    field: 'Valuation',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
    isSortIcon: true,
  },
  {
    headerName: 'oth. Chrg',
    exportHead: 'oth. Chrg',
    field: 'OtherCharge',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
    isSortIcon: true,
  },
  {
    headerName: 'Bkg. GST',
    exportHead: 'Bkg. GST',
    field: 'BookingGST',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
    isSortIcon: true,
  },

  {
    headerName: 'NetO/S Amt',
    exportHead: 'NetO/S Amt',
    field: 'Outstanding',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
    isSortIcon: true,
  },
  {
    headerName: 'Ref.\nAmt.',
    exportHead: 'Ref.\nAmt.',
    field: 'RefundAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
    isSortIcon: true,
  },
]
export const onAccountDetailedColumn1FormattedLrNo = [
  { headerName: 'S/N', exportHead: 'S/N', field: 'srNo', xlCol: { dataType: 'number', dataFormatter: null }, align: 'left' },
  {
    headerName: 'Formatted LRNO',
    exportHead: 'Formatted LRNO',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BkgDtBkgTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Src. City\nSrc. Br.',
    exportHead: 'Src. City\nSrc. Br.',
    field: 'SrcCitySrcBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dst. City\nDst. Br',
    exportHead: 'Dst. City\nDst. Br',
    field: 'DstCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Sndr. Name\nSndr. No.',
    exportHead: 'Sndr. Name\nSndr. No.',
    field: 'SendNameSendNo',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sndr. GSTIN\nSndr. eMail.',
    exportHead: 'Sndr. GSTIN\nSndr. eMail.',
    field: 'SendGstinSendEmail',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Rec. Name\nRec. No.',
    exportHead: 'Rec. Name\nRec. No.',
    field: 'RecNameRecNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Rec. GSTIN\nRec. eMail.',
    exportHead: 'Rec. GSTIN\nRec. eMail.',
    field: 'RecGstinRecEmail',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. By\nUser ',
    exportHead: 'Bkg. By\nUser',
    field: 'BkdByUser',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Item\nName',
    exportHead: 'Item\nName',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'LR\nStatus',
    exportHead: 'LR\nStatus',
    field: 'Status',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Ref. By\nRef. By Br.',
    exportHead: 'Ref. By\nRef. By Br.',
    field: 'RefByRefByBr',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Ref. Date\nRef. Time',
    exportHead: 'Ref. Date\nRef. Time',
    field: 'RefDateRefTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Item\nUnits',
    exportHead: 'Item\nUnits',
    field: 'Items',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Frt. Chrg',
    exportHead: 'Frt. Chrg',
    field: 'Freight',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Doc. Chrg',
    exportHead: 'Doc. Chrg',
    field: 'DocumentCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cart.\nChrg',
    exportHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Ham. Chrg',
    exportHead: 'Ham. Chrg',
    field: 'HamaliCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'op. Ham.',
    exportHead: 'op. Ham.',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Val. Chrg',
    exportHead: 'Val. Chrg',
    field: 'Valuation',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'oth. Chrg',
    exportHead: 'oth. Chrg',
    field: 'OtherCharge',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Bkg. GST',
    exportHead: 'Bkg. GST',
    field: 'BookingGST',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },

  {
    headerName: 'NetO/S Amt',
    exportHead: 'NetO/S Amt',
    field: 'Outstanding',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Ref.\nAmt.',
    exportHead: 'Ref.\nAmt.',
    field: 'RefundAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
]
export const onAccountDetailedColumn1Both = [
  { headerName: 'S/N', exportHead: 'S/N', field: 'srNo', xlCol: { dataType: 'number', dataFormatter: null }, align: 'left' },
  {
    headerName: 'LR No.\n Man. LR No.',
    exportHead: 'LR No.\n Man. LR No.',
    field: 'LRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Formatted LRNO',
    exportHead: 'Formatted LRNO',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. Date\nBkg. Time',
    exportHead: 'Bkg. Date\nBkg. Time',
    field: 'BkgDtBkgTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Src. City\nSrc. Br.',
    exportHead: 'Src. City\nSrc. Br.',
    field: 'SrcCitySrcBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Dst. City\nDst. Br',
    exportHead: 'Dst. City\nDst. Br',
    field: 'DstCityBranch',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Sndr. Name\nSndr. No.',
    exportHead: 'Sndr. Name\nSndr. No.',
    field: 'SendNameSendNo',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Sndr. GSTIN\nSndr. eMail.',
    exportHead: 'Sndr. GSTIN\nSndr. eMail.',
    field: 'SendGstinSendEmail',
    xlCol: { dataType: 'number', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'Rec. Name\nRec. No.',
    exportHead: 'Rec. Name\nRec. No.',
    field: 'RecNameRecNo',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Rec. GSTIN\nRec. eMail.',
    exportHead: 'Rec. GSTIN\nRec. eMail.',
    field: 'RecGstinRecEmail',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Bkg. By\nUser ',
    exportHead: 'Bkg. By\nUser',
    field: 'BkdByUser',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Item\nName',
    exportHead: 'Item\nName',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },

  {
    headerName: 'LR\nStatus',
    exportHead: 'LR\nStatus',
    field: 'Status',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Ref. By\nRef. By Br.',
    exportHead: 'Ref. By\nRef. By Br.',
    field: 'RefByRefByBr',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Ref. Date\nRef. Time',
    exportHead: 'Ref. Date\nRef. Time',
    field: 'RefDateRefTime',
    xlCol: { dataType: 'string', dataFormatter: null },
    align: 'left',
  },
  {
    headerName: 'Item\nUnits',
    exportHead: 'Item\nUnits',
    field: 'Items',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Frt. Chrg',
    exportHead: 'Frt. Chrg',
    field: 'Freight',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Doc. Chrg',
    exportHead: 'Doc. Chrg',
    field: 'DocumentCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Cart.\nChrg',
    exportHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Ham. Chrg',
    exportHead: 'Ham. Chrg',
    field: 'HamaliCharges',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'op. Ham.',
    exportHead: 'op. Ham.',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Val. Chrg',
    exportHead: 'Val. Chrg',
    field: 'Valuation',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'oth. Chrg',
    exportHead: 'oth. Chrg',
    field: 'OtherCharge',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Bkg. GST',
    exportHead: 'Bkg. GST',
    field: 'BookingGST',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },

  {
    headerName: 'NetO/S Amt',
    exportHead: 'NetO/S Amt',
    field: 'Outstanding',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
  {
    headerName: 'Ref.\nAmt.',
    exportHead: 'Ref.\nAmt.',
    field: 'RefundAmount',
    xlCol: { dataType: 'Number', dataFormatter: null },
    align: 'right',
  },
]
//manage column
export const coloumnOnAccountDetails1 = [
  {
    header: 'LR No',
    pdfHead: 'LR No.\nMan LR No',
    field: 'LRNO',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 1,
  },

  {
    header: 'Booking Date & Booking Time',
    pdfHead: ' Bkg. Date\nBkg. Time',
    field: 'BookingDateTime',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 2,
  },
  {
    header: 'Source City & Source Branch',
    pdfHead: 'Src. City\nSrc. Br.',
    field: 'BookingCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 3,
  },
  {
    header: 'Destination City & Destination Branch',
    pdfHead: 'Dst. City\nDst. Br',
    field: 'DestinationCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 4,
  },

  {
    header: 'Sender\nDetails',
    pdfHead: 'Sender\nDetails',
    field: 'Sender',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 5,
  },
  {
    header: 'Receiver\nDetails',
    pdfHead: 'Receiver\nDetails',
    field: 'Receiver',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 6,
  },
  {
    header: 'Booked By User',
    pdfHead: 'Bkg. By\nUser',
    field: 'BookedBy',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 7,
  },
  {
    header: 'Item Name',
    pdfHead: 'Item\nName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    field: 'ItemDetails',
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 8,
  },
  {
    header: 'LR Status',
    pdfHead: 'LR\nStatus',
    field: 'Status',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 9,
  },
  {
    header: 'Item Units',
    pdfHead: 'Item\nUnits',
    field: 'Items',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 10,
  },
  {
    header: 'Freight Charge',
    pdfHead: 'Frt.\nChrg',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 11,
  },
  {
    header: 'Document Charge',
    pdfHead: 'Doc.\nChrg',
    field: 'DocumentCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 12,
  },
  {
    header: 'Cartage Charge',
    pdfHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 13,
  },
  {
    header: 'Hamali Charge',
    pdfHead: 'Ham.\nChrg',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 14,
  },
  {
    header: 'Operator Hamali Charge',
    pdfHead: 'op.\nHam.',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 15,
  },

  {
    header: 'Valuation Charge',
    pdfHead: 'Val.\nChrg',
    field: 'Valuation',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 16,
  },
  {
    header: 'Other Charge',
    pdfHead: 'oth.\nChrg',
    field: 'OtherCharge',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 17,
  },
  {
    header: 'Booking GST',
    pdfHead: 'Bkg.\nGST',
    field: 'BookingGST',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 18,
  },
  {
    header: 'Net Amount',
    pdfHead: 'Net\nAmt',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 19,
  },
  {
    header: 'Delivery Hamali',
    pdfHead: 'Del.\nHam',
    field: 'DelHamali',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 20,
  },
  {
    header: 'DelCartage Amount',
    pdfHead: 'Del.\nCart',
    field: 'DelCartage',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 21,
  },
  {
    header: 'Demurrage Charge',
    pdfHead: 'Dem.\nChrg',
    field: 'DemurrageChg',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 22,
  },
  {
    header: 'Delivery GST',
    pdfHead: 'Del.\nGst',
    field: 'DeliveryGST',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 23,
  },
  {
    header: 'Net OutStanding Amount',
    pdfHead: 'NetO/S\nAmt',
    field: 'Outstanding',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 24,
  },
]

export const coloumnOnAccountDetailsFormattedLrNo = [
  {
    header: 'Formatted LRNO',
    pdfHead: 'Formatted \nLRNO',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 1,
  },
  {
    header: 'Booking Date & Booking Time',
    pdfHead: ' Bkg. Date\nBkg. Time',
    field: 'BookingDateTime',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 2,
  },
  {
    header: 'Source City & Source Branch',
    pdfHead: 'Src. City\nSrc. Br.',
    field: 'BookingCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 3,
  },
  {
    header: 'Destination City & Destination Branch',
    pdfHead: 'Dst. City\nDst. Br',
    field: 'DestinationCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 4,
  },

  {
    header: 'Sender\nDetails',
    pdfHead: 'Sender\nDetails',
    field: 'Sender',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 5,
  },
  {
    header: 'Receiver\nDetails',
    pdfHead: 'Receiver\nDetails',
    field: 'Receiver',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 6,
  },
  {
    header: 'Booked By User',
    pdfHead: 'Bkg. By\nUser',
    field: 'BookedBy',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 7,
  },
  {
    header: 'Item Name',
    pdfHead: 'Item\nName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    field: 'ItemDetails',
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 8,
  },
  {
    header: 'LR Status',
    pdfHead: 'LR\nStatus',
    field: 'Status',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 9,
  },
  {
    header: 'Item Units',
    pdfHead: 'Item\nUnits',
    field: 'Items',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 10,
  },
  {
    header: 'Freight Charge',
    pdfHead: 'Frt.\nChrg',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 11,
  },
  {
    header: 'Document Charge',
    pdfHead: 'Doc.\nChrg',
    field: 'DocumentCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 12,
  },
  {
    header: 'Cartage Charge',
    pdfHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 13,
  },
  {
    header: 'Hamali Charge',
    pdfHead: 'Ham.\nChrg',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 14,
  },
  {
    header: 'Operator Hamali Charge',
    pdfHead: 'op.\nHam.',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 15,
  },

  {
    header: 'Valuation Charge',
    pdfHead: 'Val.\nChrg',
    field: 'Valuation',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 16,
  },
  {
    header: 'Other Charge',
    pdfHead: 'oth.\nChrg',
    field: 'OtherCharge',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 17,
  },
  {
    header: 'Booking GST',
    pdfHead: 'Bkg.\nGST',
    field: 'BookingGST',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 18,
  },
  {
    header: 'Net Amount',
    pdfHead: 'Net\nAmt',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 19,
  },
  {
    header: 'Delivery Hamali',
    pdfHead: 'Del.\nHam',
    field: 'DelHamali',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 20,
  },
  {
    header: 'DelCartage Amount',
    pdfHead: 'Del.\nCart',
    field: 'DelCartage',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 21,
  },
  {
    header: 'Demurrage Charge',
    pdfHead: 'Dem.\nChrg',
    field: 'DemurrageChg',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 22,
  },
  {
    header: 'Delivery GST',
    pdfHead: 'Del.\nGst',
    field: 'DeliveryGST',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 23,
  },
  {
    header: 'Net OutStanding Amount',
    pdfHead: 'NetO/S\nAmt',
    field: 'Outstanding',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 24,
  },
]

export const coloumnOnAccountDetailsBoth = [
  {
    header: 'LR No',
    pdfHead: 'LR No.\nMan LR No',
    field: 'LRNO',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 1,
  },
  {
    header: 'Formatted LRNO',
    pdfHead: 'Formatted \nLRNO',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 2,
  },

  {
    header: 'Booking Date & Booking Time',
    pdfHead: ' Bkg. Date\nBkg. Time',
    field: 'BookingDateTime',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 3,
  },
  {
    header: 'Source City & Source Branch',
    pdfHead: 'Src. City\nSrc. Br.',
    field: 'BookingCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 4,
  },
  {
    header: 'Destination City & Destination Branch',
    pdfHead: 'Dst. City\nDst. Br',
    field: 'DestinationCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 5,
  },

  {
    header: 'Sender\nDetails',
    pdfHead: 'Sender\nDetails',
    field: 'Sender',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 6,
  },
  {
    header: 'Receiver\nDetails',
    pdfHead: 'Receiver\nDetails',
    field: 'Receiver',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 7,
  },
  {
    header: 'Booked By User',
    pdfHead: 'Bkg. By\nUser',
    field: 'BookedBy',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 8,
  },
  {
    header: 'Item Name',
    pdfHead: 'Item\nName',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    field: 'ItemDetails',
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    id: 9,
  },
  {
    header: 'LR Status',
    pdfHead: 'LR\nStatus',
    field: 'Status',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 10,
  },
  {
    header: 'Item Units',
    pdfHead: 'Item\nUnits',
    field: 'Items',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 11,
  },
  {
    header: 'Freight Charge',
    pdfHead: 'Frt.\nChrg',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 12,
  },
  {
    header: 'Document Charge',
    pdfHead: 'Doc.\nChrg',
    field: 'DocumentCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 13,
  },
  {
    header: 'Cartage Charge',
    pdfHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 14,
  },
  {
    header: 'Hamali Charge',
    pdfHead: 'Ham.\nChrg',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 15,
  },
  {
    header: 'Operator Hamali Charge',
    pdfHead: 'op.\nHam.',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 16,
  },

  {
    header: 'Valuation Charge',
    pdfHead: 'Val.\nChrg',
    field: 'Valuation',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 17,
  },
  {
    header: 'Other Charge',
    pdfHead: 'oth.\nChrg',
    field: 'OtherCharge',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 18,
  },
  {
    header: 'Booking GST',
    pdfHead: 'Bkg.\nGST',
    field: 'BookingGST',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 19,
  },
  {
    header: 'Net Amount',
    pdfHead: 'Net\nAmt',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 20,
  },
  {
    header: 'Delivery Hamali',
    pdfHead: 'Del.\nHam',
    field: 'DelHamali',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 21,
  },
  {
    header: 'DelCartage Amount',
    pdfHead: 'Del.\nCart',
    field: 'DelCartage',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 22,
  },
  {
    header: 'Demurrage Charge',
    pdfHead: 'Dem.\nChrg',
    field: 'DemurrageChg',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 23,
  },
  {
    header: 'Delivery GST',
    pdfHead: 'Del.\nGst',
    field: 'DeliveryGST',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: false,
    isSelected: true,
    isMandatory: false,
    id: 24,
  },
  {
    header: 'Net OutStanding Amount',
    pdfHead: 'NetO/S\nAmt',
    field: 'Outstanding',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    id: 25,
  },
]
// ---------------------PFD Changes----------------------
export const paymentWiseDrawCellDetail = function (data, UseFormattedLRinReports, loginCountryId) {
  var rows = data.table.body
  let indexCount = UseFormattedLRinReports === 3 ? 25 : loginCountryId !== 2 ? 24 : 22
  rows.map((val) => {
    if (data.row.section === 'head') {
      if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
        data.cell.styles.halign = 'right'
      } else {
        data.cell.styles.halign = 'left'
      }
    }
    if (val.raw.isHeading1) {
      for (let i = 0; i <= indexCount; i++) {
        val.cells[i].colSpan = 1
        val.cells[i].styles.font = 'Roboto'
        val.cells[i].styles.fontStyle = 'normal'
        val.cells[i].styles.fontSize = '16'
        val.cells[i].styles.halign = i < 10 ? 'left' : 'right'
        val.cells[i].styles.fillColor = [218, 237, 254]
      }
    }
    if (val.raw.isHeading) {
      for (let i = 0; i <= indexCount; i++) {
        val.cells[i].colSpan = 1
        val.cells[i].styles.font = 'Roboto'
        val.cells[i].styles.fontStyle = 'normal'
        val.cells[i].styles.fontSize = '16'
        // val.cells[i].styles.halign = i < 9 ? 'left' : 'right'
        val.cells[i].styles.fillColor = [218, 237, 254]
      }
    }
    if (val.raw.isSupHeading) {
      val.cells[0].colSpan = UseFormattedLRinReports === 3 ? 26 : 25
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
    }
    if (val.raw.isSubHeading) {
      var colIndex = UseFormattedLRinReports === 3 ? 7 : 6
      var colIndexTwo = UseFormattedLRinReports === 3 ? 12 : 11
      var colIndexThree = UseFormattedLRinReports === 3 ? 18 : 17
      val.cells[0].colSpan = colIndex
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
      val.cells[colIndex].colSpan = 5
      val.cells[colIndex].styles.font = 'Roboto'
      val.cells[colIndex].styles.fontStyle = 'normal'
      val.cells[colIndex].styles.fontSize = '16'
      val.cells[colIndex].styles.textColor = [0, 0, 0]
      val.cells[colIndex].styles.halign = 'left'
      val.cells[colIndex].styles.fillColor = [233, 245, 255]
      val.cells[colIndexTwo].colSpan = 6
      val.cells[colIndexTwo].styles.font = 'Roboto'
      val.cells[colIndexTwo].styles.fontStyle = 'normal'
      val.cells[colIndexTwo].styles.fontSize = '16'
      val.cells[colIndexTwo].styles.textColor = [0, 0, 0]
      val.cells[colIndexTwo].styles.halign = 'right'
      val.cells[colIndexTwo].styles.fillColor = [233, 245, 255]
      val.cells[colIndexThree].colSpan = 8
      val.cells[colIndexThree].styles.font = 'Roboto'
      val.cells[colIndexThree].styles.fontStyle = 'normal'
      val.cells[colIndexThree].styles.fontSize = '16'
      val.cells[colIndexThree].styles.textColor = [0, 0, 0]
      val.cells[colIndexThree].styles.halign = 'right'
      val.cells[colIndexThree].styles.fillColor = [233, 245, 255]
    }
    if (val.raw.isSubHeading) {
      var colIndex = UseFormattedLRinReports === 3 ? 7 : 6
      var colIndexTwo = UseFormattedLRinReports === 3 ? 12 : 11
      var colIndexThree = UseFormattedLRinReports === 3 ? 18 : 17
      val.cells[0].colSpan = colIndex
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
      val.cells[colIndex].colSpan = 5
      val.cells[colIndex].styles.font = 'Roboto'
      val.cells[colIndex].styles.fontStyle = 'normal'
      val.cells[colIndex].styles.fontSize = '16'
      val.cells[colIndex].styles.textColor = [0, 0, 0]
      val.cells[colIndex].styles.halign = 'left'
      val.cells[colIndex].styles.fillColor = [233, 245, 255]
      val.cells[colIndexTwo].colSpan = 6
      val.cells[colIndexTwo].styles.font = 'Roboto'
      val.cells[colIndexTwo].styles.fontStyle = 'normal'
      val.cells[colIndexTwo].styles.fontSize = '16'
      val.cells[colIndexTwo].styles.textColor = [0, 0, 0]
      val.cells[colIndexTwo].styles.halign = 'right'
      val.cells[colIndexTwo].styles.fillColor = [233, 245, 255]
      val.cells[colIndexThree].colSpan = 8
      val.cells[colIndexThree].styles.font = 'Roboto'
      val.cells[colIndexThree].styles.fontStyle = 'normal'
      val.cells[colIndexThree].styles.fontSize = '16'
      val.cells[colIndexThree].styles.textColor = [0, 0, 0]
      val.cells[colIndexThree].styles.halign = 'right'
      val.cells[colIndexThree].styles.fillColor = [233, 245, 255]
    }

    if (val.raw.isTotal) {
      val.cells[0].colSpan = UseFormattedLRinReports === 3 ? 10 : 9
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontS0ze = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'right'
      val.cells[0].styles.fillColor = [238, 238, 238]
      for (let i = UseFormattedLRinReports === 3 ? 10 : 9; i <= indexCount; i++) {
        val.cells[i].colSpan = 1
        val.cells[i].styles.font = 'Roboto'
        val.cells[i].styles.fontStyle = 'normal'
        val.cells[i].styles.fontSize = '16'
        val.cells[i].styles.textColor = [0, 0, 0]
        val.cells[i].styles.halign = i < 12 ? 'left' : 'right'
        val.cells[i].styles.fillColor = [238, 238, 238]
      }
    }
    if (val.raw.isTotalRefund) {
      val.cells[0].colSpan = UseFormattedLRinReports === 3 ? 15 : 14
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontS0ze = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'right'
      val.cells[0].styles.fillColor = [238, 238, 238]
      for (let i = UseFormattedLRinReports === 3 ? 15 : 14; i <= indexCount; i++) {
        val.cells[i].colSpan = 1
        val.cells[i].styles.font = 'Roboto'
        val.cells[i].styles.fontStyle = 'normal'
        val.cells[i].styles.fontSize = '16'
        val.cells[i].styles.textColor = [0, 0, 0]
        val.cells[i].styles.halign = i < 12 ? 'left' : 'right'
        val.cells[i].styles.fillColor = [238, 238, 238]
      }
    }
  })
}
export const lrDetailPdfFooter = (data, userData, totalPagesExp) => {
  const doc = data.doc
  // Footer
  var pageSize = doc.internal.pageSize
  var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
  var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

  var str = 'Page : ' + doc.internal.getNumberOfPages()
  if (typeof doc.putTotalPages === 'function') {
    str = str + ' of ' + totalPagesExp
  }
  doc.setFontSize(16)
  doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, 'right')
  doc.setFont('Roboto', 'bold')
  doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
  doc.text(
    `Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`,
    doc.internal.pageSize.width / 2 -
    (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) / 2 +
    90,
    pageHeight - 5
  )
}

export const pdfHeader = {
  0: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  1: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  2: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  3: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  4: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  5: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  6: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  7: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  8: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  9: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  10: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  11: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  12: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  13: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  14: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  15: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  16: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  17: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  18: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  19: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  20: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  21: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  22: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  23: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  24: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
}

export const pdfHeaderOne = {
  0: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  1: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  2: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  3: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  4: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  5: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  6: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  7: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  8: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  9: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  10: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  11: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  12: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  13: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  14: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  15: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  16: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  17: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  18: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  19: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  20: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  21: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  22: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  23: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  24: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  25: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
}

export const pdfHeaders = {
  0: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  1: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  2: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  3: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  4: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  5: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  6: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  7: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  8: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  9: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  10: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  11: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  12: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  13: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  14: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  15: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  16: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  17: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  18: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  19: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  20: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  21: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  22: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  23: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  24: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
}

export const pdfHeadersOne = {
  0: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  1: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  2: {
    halign: 'left',
    minCellHeight: 42,
    border: '1px solid red',
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  3: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  4: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  5: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  6: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  7: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  8: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  9: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  10: {
    halign: 'left',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  11: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  12: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  13: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  14: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  15: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  16: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  17: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  18: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  19: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  20: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  21: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  22: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  23: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  24: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
  25: {
    halign: 'right',
    minCellHeight: 36,
    fontSize: 16,
    cellPadding: 6,
    valign: 'middle',
    fontStyle: 'normal',
    font: 'Roboto',
    textColor: [0, 0, 0],
  },
}

export const coloumnOnAccountDetailsAll = [
  { id: 1, header: 'SN', pdfHead: 'SN', field: 'srNo', xlCol: { dataType: 'string', dataFormatter: null }, align: 'left', isSelected: true, isMandatory: true, },
  {
    id: 2,
    header: 'LR Number',
    pdfHead: 'LR No.\nMan LR No',
    field: 'LRNO',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
  },
  {
    id: 3,
    header: 'Formatted LRNO',
    pdfHead: 'Formatted \nLRNO',
    field: 'FormattedLRNO',
    xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    allowSorting: false,
    isSelected: true,
    isDefault: true,
    isMandatory: true,
    isSortIcon: true,
  },
  {
    id: 4,
    header: 'Booking Date & Booking Time',
    pdfHead: 'Bkg. Date\nBkg. Time',
    field: 'BookingDateTime',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    allowSorting: true,
    isSelected: true,
    isMandatory: true,
    isSortIcon: true,
  },
  {
    id: 5,
    header: 'Source City & Source Branch',
    pdfHead: 'Src. City\nSrc. Br.',
    field: 'BookingCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    isSelected: true,
    isMandatory: true,
    isSortIcon: true,
  },
  {
    id: 6,
    header: 'Destination City & Destination Branch',
    pdfHead: 'Dst. City\nDst. Br',
    field: 'DestinationCity',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    isSelected: true,
    isMandatory: true,
    isSortIcon: true,
  },
  {
    id: 7,
    header: 'Sender\nDetails',
    pdfHead: 'Sender\nDetails',
    field: 'Sender',
    xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    isSelected: true,
    isMandatory: true,
    isSortIcon: true,
  },
  {
    id: 8,
    header: 'Receiver\nDetails',
    pdfHead: 'Receiver\nDetails',
    field: 'Receiver',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
    isSelected: true,
    isMandatory: true,
    isSortIcon: true,
  },
  {
    id: 9,
    header: 'Booked By User',
    pdfHead: 'Bkg. By\nUser',
    field: 'BookedBy',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    isSelected: true,
    isMandatory: true,
    isSortIcon: true,
  },
  {
    id: 10,
    header: 'Item Name',
    pdfHead: 'Item\nName',
    field: 'ItemDetails',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    isSelected: true,
    isMandatory: true,
    isSortIcon: true,
  },
  {
    id: 11,
    header: 'LR Status',
    pdfHead: 'LR\nStatus',
    field: 'Status',
    xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'left' },
    isSelected: true,
    isMandatory: true,
    isSortIcon: true,
  },
  {
    id: 12,
    header: 'Item Units',
    pdfHead: 'Item\nUnits',
    field: 'Items',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    isSelected: true,
    isMandatory: true,
    isSortIcon: true,
  },
  {
    id: 13,
    header: 'Freight Charge',
    pdfHead: 'Frt.\nChrg',
    field: 'Freight',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    isSelected: true,
    isSortIcon: true,
  },
  {
    id: 14,
    header: 'Document Charge',
    pdfHead: 'Doc.\nChrg',
    field: 'DocumentCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    isSelected: true,
    isSortIcon: true,
  },
  {
    id: 15,
    header: 'Cartage Charge',
    pdfHead: 'Cart.\nChrg',
    field: 'CartageAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    isSelected: true,
    isSortIcon: true,
  },
  {
    id: 16,
    header: 'Hamali Charge',
    pdfHead: 'Ham.\nChrg',
    field: 'HamaliCharges',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    isSelected: true,
    isSortIcon: true,
  },
  {
    id: 17,
    header: 'Operator Hamali Charge',
    pdfHead: 'Op.\nHam.',
    field: 'OperatorHamaliChg',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    isSelected: true,
    isSortIcon: true,
  },
  {
    id: 18,
    header: 'Valuation Charge',
    pdfHead: 'Val.\nChrg',
    field: 'Valuation',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    isSelected: true,
    isSortIcon: true,
  },
  {
    id: 19,
    header: 'Other Charge',
    pdfHead: 'Oth.\nChrg',
    field: 'OtherCharge',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    isSelected: true,
    isSortIcon: true,
  },
  {
    id: 20,
    header: 'Booking GST',
    pdfHead: 'Bkg.\nGST',
    field: 'BookingGST',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    isSelected: true,
    isSortIcon: true,
  },
  {
    id: 21,
    header: 'Net Amount',
    pdfHead: 'Net\nAmt',
    field: 'NetAmount',
    xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    isSelected: true,
    isSortIcon: true,
  },
  {
    id: 22,
    header: 'Delivery Hamali',
    pdfHead: 'Del.\nHam',
    field: 'DelHamali',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    isSelected: true,
    isSortIcon: true,
  },
  {
    id: 23,
    header: 'Delivery Cartage Amount',
    pdfHead: 'Del.\nCart',
    field: 'DelCartage',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    isSelected: true,
    isSortIcon: true,
  },
  {
    id: 24,
    header: 'Demurrage Charge',
    pdfHead: 'Dem.\nChrg',
    field: 'DemurrageChg',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    isSelected: true,
    isSortIcon: true,
  },
  {
    id: 25,
    header: 'Delivery GST',
    pdfHead: 'Del.\nGst',
    field: 'DeliveryGST',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    isSelected: true,
    isSortIcon: true,
  },
  {
    id: 26,
    header: 'Net OutStanding Amount',
    pdfHead: 'NetO/S\nAmt',
    field: 'Outstanding',
    xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
    headerSx: { width: '50%', textAlign: 'right' },
    isSelected: true,
    isMandatory: true,
    isSortIcon: true,
  },
]

export const baseDetailedHeader = {
  srNo: 'SN',
  LRNO: 'LR No.\nMan LR No',
  FormattedLRNO: 'Formatted \nLRNO',
  BkgDtBkgTime: 'Bkg. Date\nBkg. Time',
  SrcCitySrcBranch: 'Src. City\nSrc. Br.',
  DstCityBranch: 'Dst. City\nDst. Br',
  SendNameSendNo: 'Sndr. Name\nSndr. No.',
  SendGstinSendEmail: 'Sndr. GSTIN\nSndr. eMail.',
  RecNameRecNo: 'Rec. Name\nRec. No.',
  RecGstinRecEmail: 'Rec. GSTIN\nRec. eMail.',
  BkdByUser: 'Bkg. By\nUser',
  ItemDetails: 'Item\nName',
  Status: 'LR\nStatus',
  RefByRefByBr: 'Ref. By\nRef. By Br.',
  RefDateRefTime: 'Ref. Date\nRef. Time',
  Items: 'Item\nUnits',
  Freight: 'Frt.\nChrg',
  DocumentCharges: 'Doc.\nChrg',
  CartageAmount: 'Cart.\nChrg',
  HamaliCharges: 'Ham.\nChrg',
  OperatorHamaliChg: 'op.\nHam.',
  Valuation: 'Val.\nChrg',
  OtherCharge: 'oth.\nChrg',
  BookingGST: 'Bkg.\nGST',
  Outstanding: 'NetO/S\nAmt.',
  RefundAmount: 'Ref.\nAmt.',
  isHeading: true,
};
export const baseDetailedHeaderFullHeader = {
  srNo: 'Serial Number',
  LRNO: 'LR Number\nManual LR Number',
  FormattedLRNO: 'Formatted \nLR Number',
  BkgDtBkgTime: 'Booking Date\nBooking Time',
  SrcCitySrcBranch: 'Source City\nSource Branch',
  DstCityBranch: 'Destination City\nDestination Branch',
  SendNameSendNo: 'Sender Name\nSender Number',
  SendGstinSendEmail: 'Sender GSTIN\nSender EMail.',
  RecNameRecNo: 'Receiver Name\nReceiver Number',
  RecGstinRecEmail: 'Receiver GSTIN\nReceiver EMail',
  BkdByUser: 'Booking By\nUser',
  ItemDetails: 'Item\nName',
  Status: 'LR\nStatus',
  RefByRefByBr: 'Refund By\nRefund By Branch',
  RefDateRefTime: 'Refund Date\nRefund Time',
  Items: 'Item\nUnits',
  Freight: 'Freight\nCharge',
  DocumentCharges: 'Document\nCharge',
  CartageAmount: 'Cartage\nCharge',
  HamaliCharges: 'Hamali\nCharge',
  OperatorHamaliChg: 'operator\nHam.',
  Valuation: 'Valuation\nCharge',
  OtherCharge: 'other\nCharge',
  BookingGST: 'Booking\nGST',
  Outstanding: 'Net Outstanding\nAmount',
  RefundAmount: 'Refund\nAmount',
  isFullHeading: true,
};